import { cloudDevOpsCampaignConfig } from '@/app/cloud-devops-platform-engineering/campaignConfig'
import { dataAnalyticsEngineeringCampaignConfig } from '@/app/data-analytics-engineering/campaignConfig'
import { mlopsForwardDeployedCampaignConfig } from '@/app/mlops-forward-deployed-engineering/campaignConfig'
import { securityEngineeringCampaignConfig } from '@/app/security-engineering/campaignConfig'
import type { InterviewPracticeCampaignConfig } from './types'

/** Canonical map: public route → page copy. Client UI resolves from URL, not a stale shared bundle. */
export const CAMPAIGN_CONFIG_BY_PATH: Readonly<
  Record<string, InterviewPracticeCampaignConfig>
> = {
  [dataAnalyticsEngineeringCampaignConfig.path]: dataAnalyticsEngineeringCampaignConfig,
  [cloudDevOpsCampaignConfig.path]: cloudDevOpsCampaignConfig,
  [securityEngineeringCampaignConfig.path]: securityEngineeringCampaignConfig,
  [mlopsForwardDeployedCampaignConfig.path]: mlopsForwardDeployedCampaignConfig,
}

export function getCampaignConfigForPath(
  pathname: string | null | undefined,
): InterviewPracticeCampaignConfig | undefined {
  if (!pathname) return undefined
  return CAMPAIGN_CONFIG_BY_PATH[pathname]
}
